import React from "react";
import { updateThemeConfig } from "../../actions";
import {
  FormGroup,
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Box,
  Tab,
  Tabs,
  FormControl,
  Typography,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import $ from "jquery";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FileUploader } from "react-drag-drop-files";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import DesignComponent from "./DesignComponent";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      style={{maxHeight:'calc( 100vh - 200px)', overflowY: 'auto', overflowX: 'hidden'}}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formControl: {
    marginTop: "10px",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  tabpanel: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
  tabpanelChild: {
    "& .MuiBox-root": {
      padding: "24px",
    },
  },
  tabpanelChild2 : {
    padding: "10px",
  }
}));

export function formatName(name) {
  // Split the color name by underscores
  const words = name.split('_');

  // Capitalize the first letter of each word
  const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

  // Join the words with a space
  const formattedName = capitalizedWords.join(' ');

  return formattedName;
}

const ThemeConfig = (props) => {
  const [value, setValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();
  return (
    <>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={(event, newValue) => {
            handleChangeTab(event, newValue);
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab
            className="QuestionConfigTab"
            label="Design"
            {...a11yProps(0)}
          />
          <Tab
            className="QuestionConfigTab"
            label="Gallery"
            {...a11yProps(1)}
          />
          <Tab className="QuestionConfigTab" label="Color" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel
        value={value}
        index={0}
        className={classes.tabpanelChild2}
      >
        <DesignComponent/>
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        className={classes.tabpanelChild}
      ></TabPanel>
      <TabPanel
        value={value}
        index={2}
        className={classes.tabpanelChild}
      ></TabPanel>
    </>
  );
};
const mapStateToProps = (state, props) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ThemeConfig);

const ImageConfig = ({ ...props }) => {
  const UNSPLASH_ACCESS_KEY = "yrSvuxwChZT_YhZm-8deptyCxtvdemUKStz8jWaDucE";
  const UNSPLASH_SECRETS_KEY = "ofsHNKmlaMJsdClrnNGXKyuKd-YC4u20zYYoKTu3ic8";

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [imgBackground, setImgBackground] = React.useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (e, reason) => {
    if (reason !== "escapeKeyDown" && reason !== "backdropClick") {
      setOpen(false);
    }
  };

  // useEffect(()=>{

  //   let key = UNSPLASH_ACCESS_KEY
  //   let url = 'https://api.unsplash.com/photos?client_id='+key+'&orientation=landscape&page=1'
  //   fetch(url)
  //   .then((response) => response.json())
  //   .then((data) => {setImgList(data)})
  // },[])
  return (
    <>
      <FormGroup className={props.classes.section}>
        <FormControl fullWidth={true}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={10}>
              <Typography component={"span"}>{props.field.name}</Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                color="primary"
                variant="outlined"
                onClick={handleClickOpen}
              >
                <AddIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12}></Grid>
          </Grid>
        </FormControl>
        <Dialog
          open={open}
          onClose={(e, reason) => {
            handleClose(e, reason);
          }}
        >
          <DialogContent>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange}>
                <Tab label="Image" {...a11yProps(0)} />
                <Tab label="Upload" {...a11yProps(1)} />
                <Tab label="Gradient" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}></TabPanel>
            <TabPanel value={value} index={1}>
              <UploadImageToS3 {...props} field={props.field} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              Gradient
            </TabPanel>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleClose}>Save Changes</Button>
          </DialogActions>
        </Dialog>
      </FormGroup>
      <Divider />
    </>
  );
};

const UploadImageToS3 = ({ ...props }) => {
  console.log(props);
  const fileTypes = ["JPG", "PNG", "GIF"];
  const [file, setFile] = React.useState();
  const [content, setContent] = React.useState(
    <>
      <CloudUploadIcon fontSize="large" />
      <span>
        <b>Choose a file</b> or drag it here!
      </span>
    </>
  );
  const handleChange = (file) => {
    handleUploadImageToS3(file, setContent, props);
  };
  return (
    <FileUploader
      handleChange={handleChange}
      name="file"
      types={fileTypes}
      children={<ContentChild content={content} />}
    />
  );
};

const ContentChild = ({ content }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        border: "2px dashed",
        width: "100%",
        height: "200px",
        borderRadius: "5px",
        cursor: "pointer",
      }}
    >
      {content}
    </div>
  );
};

function handleUploadImageToS3(file = null, setContent, { ...props }) {
  let fileName = Date.now().toString();
  let postData =
    '{"data":{"' +
    fileName +
    '_ExtraArgs":"{\\"ACL\\": \\"public-read-write\\"}","' +
    fileName +
    '_FileMeta":"{\\"project_code\\":\\"C026\\",\\"resource_type\\":\\"local.test.screenshot\\"}"},"files":{"' +
    fileName +
    '":"__file__"}}';
  postData = JSON.parse(postData);
  let ajaxData = {
    type: "POST",
    url: "https://storage.rta.vn/s3/upload",
    contentType: false,
    processData: false,
    success: (res, status, xhr) => {
      props.dispatch(
        updateThemeConfig(props.field.name, `url(${res.files[0].public_url})`)
      );
      setContent(
        <>
          <span>Upload success</span>
          <img src={res.files[0].public_url} style={{ width: "auto" }} />
        </>
      );
    },
    error: (xhr, status, error) => {
      setContent(
        <>
          <span>Upload failed. Please upload again!</span>
        </>
      );
    },
    xhr: () => {
      let jqXHR = new XMLHttpRequest();
      jqXHR.withCredentials = false;
      jqXHR.open("POST", "https://storage.rta.vn/s3/upload");
      setContent("uploading");
      return jqXHR;
    },
    timeout: 10000,
  };

  let formData = new FormData();
  Object.keys(postData.data).map((keyName) =>
    formData.append(keyName, postData.data[keyName])
  );
  if (file) {
    Object.keys(postData.files).map((keyName) =>
      formData.append(keyName, file)
    );
  }
  ajaxData["data"] = formData;
  $.ajax(ajaxData);
}

function replaceId(myid) {
  return myid.replace(/(:|\.|\[|\]|,|=|@)/g, "\\$1");
}
